"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListGroupDisplayType = void 0;
var ListGroupDisplayType;
(function (ListGroupDisplayType) {
    ListGroupDisplayType["HORIZONTAL"] = "horizontal";
    ListGroupDisplayType["VERTICAL"] = "vertical";
})(ListGroupDisplayType || (exports.ListGroupDisplayType = ListGroupDisplayType = {}));
